export enum EActionTypes {
    IndeedCreateCampaign = 1,
    IndeedUpdateCampaignDetails = 2,
    IndeedUpdateCampaignBudget = 3,
    IndeedAttachJobsToCampaign = 4,
    IndeedAlgoControlRequest = 5
}